import React, { createElement, useMemo } from "react";
import PropTypes from "prop-types";
import { useI18n } from "./hooks";

const I18n = props => {
  const { children, params, as: Component, ...otherProps } = props;

  const { formatMessage, DefaultTextComponent } = useI18n()

  const TextComponent = useMemo(
    () => Component || DefaultTextComponent,
    [Component, DefaultTextComponent]
  )

  return createElement(
    TextComponent,
    otherProps,
    formatMessage({ id: children }, params)
  )
};

I18n.propTypes = {
  params: PropTypes.object,
  children: PropTypes.string.isRequired,
  as: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ])
};

I18n.defaultProps = {
  params: {},
  as: undefined
};

export default I18n
